<template>
  <div>
    <div class="d-flex mb-8">
      <h2 class="font-weight-bold mb-6">{{ $t('carbonCredit.plotTreeMapping.techniciansPlotsTitle') }}</h2>
      <v-spacer />
      <v-btn color="primary" dark @click="$emit('back')">
        {{ $t('back') }}
      </v-btn>
    </div>

    <v-card elevation="0" class="px-5 mt-7">
      <v-card-text>
        <v-row style="margin-left: -30px; margin-bottom: 20px; margin-top: 15px;">
          <v-col cols="12">
            <v-data-table
              :headers="displayHeaders"
              :items="items"
              :items-per-page="options.limit"
              :footer-props="{ 'items-per-page-options': itemsPerPageOptions }"
              item-key="_rowKey"
              hide-default-footer
              :loading="tableLoading"
              :options.sync="options"
              :server-items-length="totalPlots"
              :loading-text="$t('loadingData')"
              :no-data-text="$t('carbonCredit.plotTreeMapping.noTechnicianPlots')"
              class="technician-plots-table"
            >
              <template v-slot:top>
                <div class="d-flex mt-5 align-center">
                  <div class="ml-3" style="width: 220px;">
                    <label for="text"> </label>
                    <v-text-field
                      prepend-inner-icon="mdi-magnify"
                      outlined
                      :placeholder="$t('carbonCredit.search')"
                      dense
                      v-model="search"
                      @input="searchQuery"
                      class="shrink"
                    ></v-text-field>
                  </div>
                  <div class="ml-3" style="width: 220px;">
                    <v-select
                      v-model="filters.projectId"
                      :items="projectFilterOptions"
                      :label="$t('carbonCredit.plotTreeMapping.project')"
                      item-text="project_title"
                      item-value="id"
                      dense
                      outlined
                      hide-details
                      clearable
                      :loading="projectsLoading"
                      @change="onFilterChange"
                    />
                  </div>
                  <div class="ml-3" style="width: 200px;">
                    <v-select
                      v-model="filters.addedBy"
                      :items="addedByOptions"
                      :label="$t('carbonCredit.plotTreeMapping.addedBy')"
                      item-text="displayName"
                      item-value="id"
                      dense
                      outlined
                      hide-details
                      clearable
                      :loading="creatorsLoading"
                      @change="onFilterChange"
                    />
                  </div>
                  <div class="ml-3" style="width: 200px;">
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="filters.date"
                          :label="$t('carbonCredit.plotTreeMapping.filterByDate')"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          hide-details
                          clearable
                          v-bind="attrs"
                          v-on="on"
                          @click:clear="clearDateFilter"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="filters.date"
                        @input="onDateSelected"
                      />
                    </v-menu>
                  </div>
                  <v-spacer></v-spacer>
                  <div class="py-1 title">
                    {{ fromPlots }} - {{ toPlots }} {{ $t('of') }} {{ totalPlots }}
                  </div>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="options.page <= 1"
                    @click="pageChange(false)"
                  >
                    <v-icon dark>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-btn
                    class="mx-2"
                    fab
                    small
                    outlined
                    color="primary"
                    :disabled="options.page >= totalPages"
                    @click="pageChange(true)"
                  >
                    <v-icon dark>mdi-chevron-right</v-icon>
                  </v-btn>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    left
                    :min-width="417"
                  >
                    <template v-slot:activator="props">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="props.attrs"
                        v-on="props.on"
                      >
                        <v-icon dark>mdi-cog-outline</v-icon>
                      </v-btn>
                    </template>
                    <v-card width="417">
                      <v-list>
                        <v-list-item>
                          <v-list-item-title>{{ $t('customization') }}</v-list-item-title>
                        </v-list-item>
                        <v-divider></v-divider>
                        <div class="pl-3 pt-2 font-weight-normal">
                          {{ $t('recordsPerPage') }}
                        </div>
                        <v-list-item>
                          <v-slider
                            v-model="itemsPerPageSlider"
                            :tick-labels="itemsPerPageOptions"
                            :max="3"
                            step="1"
                            ticks="always"
                            tick-size="4"
                          ></v-slider>
                        </v-list-item>
                        <v-divider class="mt-n3"></v-divider>
                      </v-list>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="mt-n9"
                              cols="6"
                              v-for="header in headers"
                              :key="header.value"
                            >
                              <v-checkbox
                                v-if="header.text"
                                v-model="selectedHeaders"
                                :label="header.text"
                                color="primary"
                                :value="header.text"
                                hide-details
                              ></v-checkbox>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-layout justify-center>
                        <v-card-actions class="mb-5">
                          <v-spacer></v-spacer>
                          <v-btn outlined color="primary" @click="resetDefault" width="190">
                            {{ $t('restoreDefault') }}
                          </v-btn>
                          <v-btn color="primary" @click="resetTableStructure" width="190">
                            {{ $t('apply') }}
                          </v-btn>
                        </v-card-actions>
                      </v-layout>
                    </v-card>
                  </v-menu>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="openDownloadDialog"
                      >
                        <v-img src="/icons/download.svg"></v-img>
                      </v-btn>
                    </template>
                    <span>{{ $t('Download') }}</span>
                  </v-tooltip>
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="props">
                      <v-btn
                        class="mx-2"
                        fab
                        small
                        outlined
                        color="primary"
                        v-bind="props.attrs"
                        v-on="props.on"
                        @click="printTable"
                      >
                        <v-icon dark>mdi-printer</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('Print') }}</span>
                  </v-tooltip>
                </div>
              </template>

              <template v-slot:item.plot_no="{ item }">
                <span class="font-weight-medium">{{ safeText(item.plot_no) }}</span>
              </template>

              <template v-slot:item.addedBy="{ item }">
                <span>{{ safeText(item.added_by_name || item.added_by_display) }}</span>
                <span v-if="item.added_by_role" class="technician-role-tag ml-1">
                  ({{ item.added_by_role }})
                </span>
              </template>

              <template v-slot:item.numberOfTrees="{ item }">
                <span class="font-weight-medium">{{ treeCount(item) }}</span>
              </template>

              <template v-slot:item.project="{ item }">
                <span>{{ safeText(item.project?.project_title || 'NA') }}</span>
              </template>

              <template v-slot:item.createdAt="{ item }">
                <span>{{ formatDate(item.plot_linked_at || item.created_at) }}</span>
              </template>

              <template v-slot:item.action="{ item }">
                <v-menu offset-y left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item @click="viewPlot(item)">
                      <v-list-item-title>View</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadPlot(item)">
                      <v-list-item-title>{{ $t('Download') }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openRemoveConfirm(item)">
                      <v-list-item-title class="red--text">Remove</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:no-data>
                <div class="technician-plots-empty py-12 text-center">
                  <v-icon size="48" color="grey lighten-1">mdi-map-marker-radius-outline</v-icon>
                  <p class="text-h6 grey--text text--darken-1 mt-4 mb-1">
                    {{ $t('carbonCredit.plotTreeMapping.noTechnicianPlots') }}
                  </p>
                  <p class="body-2 grey--text mb-4">
                    {{ $t('carbonCredit.plotTreeMapping.noTechnicianPlotsHint') }}
                  </p>
                  <v-btn
                    v-if="hasActiveFilters"
                    outlined
                    color="primary"
                    small
                    @click="clearAllFilters"
                  >
                    {{ $t('carbonCredit.plotTreeMapping.clearFilters') }}
                  </v-btn>
                </div>
              </template>

              <template v-slot:footer></template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <PlotDetails
      v-if="showPlotDetailsDialog"
      :dialog="showPlotDetailsDialog"
      :plot="selectedPlot"
      :request-id="selectedPlot.tree_mapping_request_id"
      :is-technician-plot="true"
      @close="showPlotDetailsDialog = false"
    />

    <v-dialog v-model="downloadDialog" max-width="420">
      <v-card>
        <v-toolbar color="primary" elevation="0" class="white--text">
          <v-toolbar-title class="white--text font-weight-bold">
            Download options
          </v-toolbar-title>
          <v-spacer />
          <v-btn color="white" icon @click="downloadDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-6 pb-4">
          <div class="subtitle-1 mb-2">
            Choose what to include in the download.
          </div>
          <div class="body-2">
            Current page uses the records visible in the table now.
            All records uses every record matching the current filters.
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn text color="primary" @click="downloadDialog = false">
            Cancel
          </v-btn>
          <v-btn color="primary" class="ml-2" @click="confirmDownload('page')">
            Current page
          </v-btn>
          <v-btn color="primary" class="ml-2" @click="confirmDownload('all')">
            All records
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirmRemoveDialog" persistent max-width="500">
      <v-card>
        <v-toolbar color="primary" elevation="0" class="white--text">
          <v-toolbar-title class="white--text font-weight-bold">Confirmation</v-toolbar-title>
          <v-spacer />
          <v-btn color="white" icon @click="confirmRemoveDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-8 pb-6 text-center">
          <p class="black--text mb-0">
            {{ $t('carbonCredit.plotTreeMapping.removeTechnicianPlotMessage', { plotNo: removePlotNo }) }}
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn outlined color="primary" @click="confirmRemoveDialog = false">
            {{ $t('carbonCredit.plotTreeMapping.cancel') }}
          </v-btn>
          <v-btn color="primary" class="white--text ml-3" depressed @click="confirmRemovePlot">
            {{ $t('remove') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment';
import html2pdf from 'html2pdf.js';
import printJS from 'print-js';
import CarbonCreditService from '@/_services/CarbonCreditService';
import loadingMixin from '@/mixins/LoadingMixin';
import { decodeHtmlEntities } from '@/utils.js';
import PlotDetails from './PlotDetails.vue';

const SORT_FIELD_MAP = {
  plot_no: 'plot_no',
  numberOfTrees: 'no_of_trees',
  createdAt: 'plot_linked_at',
};

export default {
  name: 'TechnicianPlotsView',
  mixins: [loadingMixin],
  components: { PlotDetails },
  data() {
    return {
      debounceTimer: null,
      tableLoading: false,
      search: '',
      filters: {
        projectId: null,
        addedBy: null,
        date: null,
      },
      dateMenu: false,
      projectFilterOptions: [],
      projectsLoading: false,
      addedByOptions: [],
      creatorsLoading: false,
      headers: [
        {
          text: 'Plot Number',
          align: 'start',
          value: 'plot_no',
          class: 'black--text',
          sortable: true,
        },
        {
          text: 'Added By',
          align: 'start',
          value: 'addedBy',
          class: 'black--text',
          sortable: false,
        },
        {
          text: 'Number of Trees',
          align: 'start',
          value: 'numberOfTrees',
          class: 'black--text',
          sortable: true,
        },
        {
          text: this.$t('carbonCredit.plotTreeMapping.project'),
          align: 'start',
          value: 'project',
          class: 'black--text',
          sortable: false,
        },
        {
          text: 'Plot Created On',
          align: 'start',
          value: 'createdAt',
          class: 'black--text',
          sortable: true,
        },
        {
          align: 'center',
          value: 'action',
          class: 'black--text',
          sortable: false,
        },
      ],
      allSelectedHeaders: [
        'Plot Number',
        'Added By',
        'Number of Trees',
        this.$t('carbonCredit.plotTreeMapping.project'),
        'Plot Created On',
      ],
      items: [],
      totalPlots: 0,
      options: {
        limit: 10,
        page: 1,
        sortBy: ['createdAt'],
        sortDesc: [true],
      },
      itemsPerPageOptions: [5, 10, 25, 50],
      itemsPerPageSlider: 1,
      selectedHeaders: [],
      tableHeaders: [],
      showActionsColumn: true,
      hideOnPrint: false,
      menu: false,
      selectedItem: false,
      showPlotDetailsDialog: false,
      selectedPlot: {},
      confirmRemoveDialog: false,
      plotToRemove: null,
      downloadDialog: false,
    };
  },
  computed: {
    displayHeaders() {
      return this.showActionsColumn
        ? this.tableHeaders
        : this.tableHeaders.filter((header) => header.value !== 'action');
    },
    totalPages() {
      return parseInt(Math.ceil(this.totalPlots / this.options.limit), 10) || 1;
    },
    fromPlots() {
      return this.totalPlots > 0 ? (this.options.page - 1) * this.options.limit + 1 : 0;
    },
    toPlots() {
      const end = this.options.page * this.options.limit;
      return end > this.totalPlots ? this.totalPlots : end;
    },
    removePlotNo() {
      return this.plotToRemove?.plot_no || '';
    },
    hasActiveFilters() {
      return !!(
        this.search ||
        this.filters.projectId ||
        this.filters.addedBy ||
        this.filters.date
      );
    },
  },
  watch: {
    options: {
      handler(opt) {
        this.fetchPlots(opt);
      },
      deep: true,
    },
    showActionsColumn() {
      this.updateDisplayHeaders();
    },
  },
  mounted() {
    this.tableHeaders = this.headers;
    this.selectedHeaders = this.allSelectedHeaders;
  },
  created() {
    this.fetchPlots();
    this.fetchProjects();
    this.fetchCreators();
  },
  methods: {
    plotTreeMappingApiContext() {
      const project = (this.projectFilterOptions || []).find(
        (p) => Number(p.id) === Number(this.filters.projectId)
      );
      return {
        selectedProjectId: this.filters.projectId,
        projectOptions: this.projectFilterOptions,
        project,
      };
    },
    safeText(val) {
      return decodeHtmlEntities(val);
    },
    treeCount(item) {
      const n = item?.number_of_trees ?? item?.no_of_trees;
      return n != null && n !== '' ? Number(n) : 0;
    },
    clearAllFilters() {
      this.search = '';
      this.filters = { projectId: null, addedBy: null, date: null };
      this.options.page = 1;
      this.fetchPlots();
    },
    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return moment(dateString).format('DD-MMM-YYYY').toUpperCase();
    },
    buildFetchParams(overrides = {}) {
      const params = {
        page: overrides.page ?? this.options.page ?? 1,
        limit: overrides.limit ?? this.options.limit ?? 10,
        search: this.search || undefined,
        addedBy: this.filters.addedBy || undefined,
        projectId: this.filters.projectId || undefined,
        date: this.filters.date || undefined,
      };

      const sortBy = overrides.sortBy ?? this.options.sortBy;
      const sortDesc = overrides.sortDesc ?? this.options.sortDesc;
      if (sortBy?.length) {
        const col = sortBy[0];
        params.sortBy = SORT_FIELD_MAP[col] || col;
        params.sortType = sortDesc?.[0] ? 'DESC' : 'ASC';
      }

      return params;
    },
    async fetchPlots(opt = null) {
      this.tableLoading = true;
      const params = this.buildFetchParams({
        page: this.options.page,
        limit: this.options.limit,
        sortBy: opt?.sortBy ?? this.options.sortBy,
        sortDesc: opt?.sortDesc ?? this.options.sortDesc,
      });

      try {
        const response = await CarbonCreditService.getTechnicianPlots(params);
        if (response.success) {
          this.items = response.data.rows || [];
          this.totalPlots = response.data.total || response.data.count || 0;
        } else {
          this.$notify({ type: 'error', text: response.message || 'Failed to fetch technician plots' });
        }
      } catch (error) {
        console.error('Error fetching technician plots:', error);
        this.$notify({ type: 'error', text: 'An error occurred while fetching technician plots' });
      } finally {
        this.tableLoading = false;
      }
    },
    async fetchAllPlotsForExport() {
      const response = await CarbonCreditService.getTechnicianPlots({
        ...this.buildFetchParams(),
        page: 1,
        limit: this.totalPlots || 500,
      });
      if (response.success) {
        return response.data.rows || [];
      }
      return [];
    },
    async fetchProjects() {
      this.projectsLoading = true;
      try {
        const response = await CarbonCreditService.getPlotTreeMappingProjects({ limit: 500 });
        if (response.success) {
          this.projectFilterOptions = response.data || [];
        }
      } catch (error) {
        this.projectFilterOptions = [];
      } finally {
        this.projectsLoading = false;
      }
    },
    isTechnicianRole(role) {
      if (!role) return false;
      const id = String(role.id || '').toLowerCase();
      const name = String(role.name || '').toLowerCase();
      return id === 'technician' || name === 'technician' || id.includes('technician') || name.includes('technician');
    },
    async resolveTechnicianRoleId() {
      try {
        const cached = this.$store.getters['carbonCredit/getCachedUserMembershipRoleResponse'];
        let payload = cached;
        if (!payload?.data?.listRes) {
          const res = await this.$http.get('/user/membership/user-role');
          payload = res.data;
          this.$store.commit('carbonCredit/SET_USER_MEMBERSHIP_ROLE_RESPONSE', payload);
        }
        const roles = (payload?.data?.listRes || []).filter((r) => r.id !== 'avocado_farmer');
        const technicianRole = roles.find((r) => this.isTechnicianRole(r));
        return technicianRole?.id || null;
      } catch (error) {
        console.error('Error resolving technician role:', error);
        return null;
      }
    },
    formatAddedByUser(user) {
      const id = user.userId ?? user.id;
      const fullName =
        user.fullName ||
        `${user.first_name || user.firstName || ''} ${user.last_name || user.lastName || ''}`.trim() ||
        `User ${id}`;
      return { id, fullName, displayName: fullName };
    },
    /** Same user list source as Add Plot Tree when Assign To = Technician */
    async fetchCreators() {
      this.creatorsLoading = true;
      try {
        const roleId = await this.resolveTechnicianRoleId();
        if (!roleId) {
          this.addedByOptions = [];
          return;
        }
        const res = await CarbonCreditService.getUsersByRole({
          role_id: roleId,
          page: 1,
          limit: 1000,
        });
        const raw = res?.data ?? (Array.isArray(res) ? res : []);
        const list = Array.isArray(raw) ? raw : [];
        this.addedByOptions = list
          .map((u) => this.formatAddedByUser(u))
          .filter((u) => u.id != null)
          .sort((a, b) => a.fullName.localeCompare(b.fullName));
      } catch (error) {
        console.error('Error fetching technician users:', error);
        this.addedByOptions = [];
      } finally {
        this.creatorsLoading = false;
      }
    },
    searchQuery() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.options.page = 1;
        this.fetchPlots();
      }, 500);
    },
    onFilterChange() {
      this.options.page = 1;
      this.fetchPlots();
    },
    onDateSelected() {
      this.dateMenu = false;
      this.onFilterChange();
    },
    clearDateFilter() {
      this.filters.date = null;
      this.onFilterChange();
    },
    pageChange(next) {
      if (next) this.options.page += 1;
      else this.options.page -= 1;
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    async resetDefault() {
      this.tableHeaders = this.headers;
      this.selectedHeaders = this.allSelectedHeaders;
      this.menu = false;
      await this.fetchPlots();
    },
    async resetTableStructure() {
      this.tableHeaders = this.headers.filter(
        (header) =>
          (header.text && this.selectedHeaders.includes(header.text)) ||
          (!header.text)
      );
      this.options.limit = this.itemsPerPageOptions[this.itemsPerPageSlider];
      await this.fetchPlots();
      this.menu = false;
    },
    updateDisplayHeaders() {
      this.tableHeaders = this.headers.filter(
        (header) =>
          (header.text && this.selectedHeaders.includes(header.text)) ||
          (this.showActionsColumn && header.value === 'action') ||
          (!header.text && !this.showActionsColumn)
      );
    },
    openDownloadDialog() {
      this.downloadDialog = true;
    },
    async confirmDownload(scope) {
      this.downloadDialog = false;
      await this.exportTableDownload(scope);
    },
    async exportTableDownload(scope) {
      if (scope === 'all' && this.totalPlots > this.items.length) {
        this.startLoading();
        try {
          const allRows = await this.fetchAllPlotsForExport();
          const previousItems = this.items;
          this.items = allRows;
          this.showActionsColumn = false;
          await this.$nextTick();
          await this.printTable();
          this.items = previousItems;
          this.showActionsColumn = true;
        } finally {
          this.stopLoading();
        }
        return;
      }
      await this.printTable();
    },
    async printTable() {
      this.showActionsColumn = false;
      this.hideOnPrint = true;
      await this.$nextTick();
      const element = document.querySelector('.v-data-table__wrapper');
      const opt = {
        margin: 1,
        filename: 'TechnicianPlots.pdf',
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
      };
      const worker = await html2pdf()
        .set(opt)
        .from(element)
        .toCanvas()
        .outputPdf('blob', 'TechnicianPlots.pdf');
      const file = new File([worker], 'TechnicianPlots.pdf', { type: 'application/pdf' });
      const pdfUrl = await URL.createObjectURL(file);
      await printJS({ printable: `${pdfUrl}`, type: 'pdf', showModal: true });
      this.showActionsColumn = true;
      this.hideOnPrint = false;
      await this.$nextTick();
    },
    async viewPlot(item) {
      try {
        this.startLoading();
        const response = await CarbonCreditService.getTechnicianPlotById(item.id);
        if (response.success) {
          this.selectedPlot = response.data;
          this.showPlotDetailsDialog = true;
        }
      } catch (error) {
        this.$notify({ type: 'error', text: 'Failed to load plot details' });
      } finally {
        this.stopLoading();
      }
    },
    async downloadPlot(item) {
      try {
        this.startLoading();
        const response = item.tree_mapping_request_id
          ? await CarbonCreditService.downloadPlotDetails(item.tree_mapping_request_id, item.id, 'pdf')
          : await CarbonCreditService.downloadTechnicianPlotDetails(item.id, 'pdf');
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `technician-plot-${item.plot_no || item.id}.pdf`;
        link.click();
        URL.revokeObjectURL(url);
        this.$notify({ type: 'success', text: 'Download started' });
      } catch (error) {
        this.$notify({ type: 'error', text: 'Failed to download plot' });
      } finally {
        this.stopLoading();
      }
    },
    openRemoveConfirm(item) {
      this.plotToRemove = item;
      this.confirmRemoveDialog = true;
    },
    async confirmRemovePlot() {
      if (!this.plotToRemove) return;
      try {
        this.startLoading();
        const response = await CarbonCreditService.deleteTreePlot(this.plotToRemove.id);
        if (response.success) {
          this.$notify({ type: 'success', text: 'Plot removed successfully' });
          await this.fetchPlots();
          await this.fetchCreators();
        } else {
          this.$notify({ type: 'error', text: response.msg || 'Failed to remove plot' });
        }
      } catch (error) {
        this.$notify({ type: 'error', text: 'Failed to remove plot' });
      } finally {
        this.stopLoading();
        this.confirmRemoveDialog = false;
        this.plotToRemove = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.technician-plots-table::v-deep .v-data-table-header {
  background-color: var(--secondary-color, #117443) !important;
}

.technician-plots-table::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: white !important;
}

.technician-plots-table::v-deep tbody tr:hover {
  background-color: #f5faf8 !important;
}

.technician-plots-table::v-deep tbody tr:nth-child(even) {
  background-color: #fafafa;
}

.technician-role-tag {
  font-weight: 500;
}

.technician-plots-empty {
  min-height: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
